export default {
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    backClick() {
      this.$router.back();
    }
  }
};